module.exports = __webpack_public_path__ + "static/media/WSEnergy_News_Picture.8037eec8.png";